import React, { Component } from 'react';
import {
  Form,
  FormFeedback,
  Input,
} from 'reactstrap';
import LoadingButton from "../../../shared/ui/LoadingButton";

class RatingsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        riskAlert: '',
        scale: '',
      },
      errorFeedback: {},
      isRiskAlertValid: true,
      isScaleValid: true,
      properties: {
        riskAlert: this.props.initialValues.riskAlert,
        scale: this.props.initialValues.scale,
      },
    };
  }

  // ----------------------
  // Computed
  // ----------------------

  get isFormDisabled() {
    const isTouched = (this.state.properties.riskAlert !== this.props.initialValues.riskAlert)
        || (this.state.properties.scale !== this.props.initialValues.scale);
    return !isTouched
      || !this.state.isRiskAlertValid
      || !this.state.isScaleValid;
  }

  get riskAlertValues() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9].filter(value => value <= (this.state.properties.scale - 1));
  }

  get scaleValues() {
    return [3, 4, 5, 6, 7, 8, 9, 10];
  }

  // ----------------------
  // Methods
  // ----------------------

  handleScaleInput(event) {
    const value = parseInt(event.target.value, 10);
    const updateScale = (state) => {
      if (value === this.props.initialValues.scale) {
        return {
          cssValidationClasses: {
            riskAlert: 'is-valid',
            scale: 'is-valid',
          },
          errorFeedback: { },
          isScaleValid: true,
          properties: {
            riskAlert: state.properties.riskAlert,
            scale: value,
          },
        };
      }
      return {
        cssValidationClasses: {
          riskAlert: 'is-invalid',
          scale: 'is-valid',
        },
        errorFeedback: { riskAlert: 'Must be reset after scale change.' },
        isRiskAlertValid: false,
        isScaleValid: true,
        properties: {
          ...state.properties,
          scale: value,
        },
      };
    };
    this.setState(updateScale);
  }

  handleRiskAlertInput(event) {
    const value = parseInt(event.target.value, 10);
    const riskAlertPropertiesUpdateFn = (state) => {
      return {
        cssValidationClasses: {
          ...state.cssValidationClasses,
          riskAlert: 'is-valid',
        },
        errorFeedback: state.errorFeedback.scale
          ? { scale: state.errorFeedback.scale } : {},
        isRiskAlertValid: true,
        properties: {
          ...state.properties,
          riskAlert: value,
        },
      };
    };
    this.setState(riskAlertPropertiesUpdateFn);
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      riskAlert: this.state.properties.riskAlert,
      scale: this.state.properties.scale,
    };
    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <div className="form-group">
          <label htmlFor="scale">Risk Alert <i className="fa fa-asterisk" /></label>
          <Input
            className={this.state.cssValidationClasses.riskAlert}
            id="riskAlert"
            name="riskAlert"
            onChange={event => this.handleRiskAlertInput(event)}
            type="select"
            value={this.state.properties.riskAlert}
          >
            {this.riskAlertValues.map((value, index) => (
              <option key={index.toString()} value={value}>{value}</option>
            ))}
          </Input>
          <FormFeedback>{this.state.errorFeedback.riskAlert}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="scale">Rating Maximum <i className="fa fa-asterisk" /></label>
          <Input
            className={this.state.cssValidationClasses.scale}
            id="scale"
            name="scale"
            onChange={event => this.handleScaleInput(event)}
            type="select"
            value={this.state.properties.scale}
          >
            {this.scaleValues.map((value, index) => (
              <option key={index.toString()} value={value}>{value}</option>
            ))}
          </Input>
          <FormFeedback>{this.state.errorFeedback.scale}</FormFeedback>
        </div>
        <div style={{ textAlign: 'right' }}>
          <LoadingButton
            primary
            text={'Submit'}
            isLoading={this.props.isLoading}
            disabled={this.isFormDisabled}/>
        </div>
      </Form>
    );
  }
}

export default RatingsForm;
